import { WHATSAPP_LINK } from "@/pages/home/constants";
import { heroImage } from "@/mocks/homeData";

export default function Hero() {
  return (
    <section id="inicio" className="relative w-full scroll-mt-16">
      <div className="relative w-full h-[480px] md:h-[600px] lg:h-[660px] overflow-hidden">
        <img
          src={heroImage}
          alt="Passeio de lancha em Capitólio com cânions no Lago de Furnas - Eco Tour Turismo"
          title="Passeio de Lancha Capitólio - Eco Tour Turismo"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/55 to-primary-950/10" />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-transparent to-primary-950/30" />

        <span className="hidden md:inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#E6394A] text-white text-[11px] font-bold uppercase tracking-wide whitespace-nowrap animate-pulse absolute top-24 right-8 z-10">
          <i className="ri-fire-fill text-sm" />
          Vagas limitadas para esta temporada
        </span>

        <div className="absolute inset-0 flex items-center">
          <div className="w-full px-4 md:px-6 lg:px-8">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white/10 border border-white/20 backdrop-blur-sm text-[11px] md:text-xs font-semibold text-white/90 mb-3">
                <i className="ri-map-pin-2-fill text-accent-400" />
                Capitólio · Lago de Furnas · Minas Gerais
              </span>

              <p className="font-heading text-[11px] md:text-sm font-semibold tracking-[0.3em] text-accent-400 uppercase mb-3">
                Viva o Mar de Minas
              </p>

              <h1 className="text-2xl md:text-4xl lg:text-[2.9rem] font-heading font-bold text-white leading-[1.15] mb-3 tracking-tight">
                Passeio de Lancha em Capitólio pelo Lago de Furnas
              </h1>

              <p className="text-sm md:text-base text-white/80 leading-relaxed mb-4 max-w-lg">
                Descubra os cânions, cachoeiras e lagoas do Lago de Furnas em um passeio de lancha completo,
                com conforto, segurança e atendimento personalizado.
              </p>

              <div className="mb-4 flex md:hidden justify-end">
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#E6394A] text-white text-[10px] font-bold uppercase tracking-wide whitespace-nowrap animate-pulse">
                  <i className="ri-fire-fill text-[11px]" />
                  Vagas limitadas para esta temporada
                </span>
              </div>

              <div className="flex flex-wrap items-center gap-3">
                <a
                  href={WHATSAPP_LINK}
                  data-whatsapp-cta
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-md text-sm font-bold bg-accent-500 text-primary-950 hover:bg-accent-400 transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line text-lg" />
                  Reservar pelo WhatsApp
                </a>
                <a
                  href="#passeio-de-lancha"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-md text-sm font-semibold text-white border border-white/30 hover:bg-white/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  Conhecer os passeios
                  <i className="ri-arrow-down-line text-base" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}